















import Vue from "vue";
import Component from "vue-class-component";
import { EventInterface, SlotGroupInterface } from "@/types";
import EventEditorSlotGroup from "@/components/arma/events/editor/EventEditorSlotGroup.vue";
import SlotGroupController from "../../../../classes/SlotGroupController";
import SlotGroup from "@/classes/SlotGroup";
import { ModelSync, Prop, Watch } from "vue-property-decorator";

@Component({
  name: "EventEditorSlotGroups",
  components: { EventEditorSlotGroup },
})
export default class EventEditorSlotGroups extends Vue {
  public get isOnlySlotGroup(): boolean {
    return this.slotGroups.length === 1;
  }

  @ModelSync("eventValue", "input")
  public readonly event!: Partial<EventInterface>;

  protected slotGroups: SlotGroup[] = [];
  protected slotGroupController = new SlotGroupController();

  public addNewSlotGroupToEvent() {
    const slotGroup = this.slotGroupController.createSlotGroup();
    this.slotGroups.push(slotGroup);
  }

  public copySlotGroup(previous: number) {
    const slotGroup = this.slotGroupController.copySlotGroup(
      this.slotGroups[previous]
    );
    this.slotGroups.push(slotGroup);
  }

  public removeSlotGroupFromEvent(index: number) {
    this.slotGroupController.removeSlotGroup(index, this.slotGroups);
  }

  public renameSlotGroup(newName: string, slotGroup: SlotGroup) {
    this.slotGroupController.renameSlotGroup(slotGroup, newName);
  }

  public isLastElement<T>(index: number, array: T[]): boolean {
    return index === array.length - 1;
  }

  public getCopySlotGroups(eventJson: string) {
    const previous = JSON.parse(eventJson);

    const slotGroups: SlotGroup[] = [];
    previous.slotGroups.forEach((previousGroup: SlotGroup) => {
      slotGroups.push(
        new SlotGroup(
          previousGroup.name,
          previousGroup.description,
          previousGroup.playerSlots
        )
      );
    });

    return slotGroups;
  }

  public mounted() {
    const copyEventJson = localStorage.getItem("copyEvent");
    if (copyEventJson !== null) {
      this.slotGroups = this.getCopySlotGroups(copyEventJson);
    } else {
      this.addNewSlotGroupToEvent();
      this.event.slotGroups = this.slotGroups;
    }
  }

  @Watch("slotGroups", { immediate: true })
  private slotGroupsChanged() {
    this.event.slotGroups = this.slotGroups;
  }
}
